import { render, staticRenderFns } from "./productSelection.vue?vue&type=template&id=2da91aa1&scoped=true"
import script from "./productSelection.vue?vue&type=script&lang=js"
export * from "./productSelection.vue?vue&type=script&lang=js"
import style0 from "./productSelection.vue?vue&type=style&index=0&id=2da91aa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da91aa1",
  null
  
)

export default component.exports